export function openUrl(url: string): void {
  window.open(url, '_blank');
}

export function copyUrl(url: string): void {
  navigator.clipboard.writeText(url);
}